const zones = {
  AF: ['AO', 'BF', 'BI', 'BJ', 'BW', 'CD', 'CF', 'CG', 'CI', 'CM', 'CV', 'DJ', 'DZ', 'EG', 'EH', 'ER', 'ET', 'GA', 'GH', 'GM', 'GN', 'GQ', 'GW', 'KE', 'KM', 'LR', 'LS', 'LY', 'MA', 'MG', 'ML', 'MR', 'MU', 'MW', 'MZ', 'NA', 'NE', 'NG', 'RE', 'RW', 'SC', 'SD', 'SL', 'SN', 'SO', 'ST', 'SZ', 'TD', 'TG', 'TN', 'TZ', 'UG', 'YT', 'ZA', 'ZM', 'ZW'],
  AS: ['AE', 'AF', 'AM', 'AZ', 'BD', 'BH', 'BN', 'BT', 'CC', 'CN', 'CX', 'CY', 'GE', 'HK', 'ID', 'IL', 'IN', 'IO', 'IQ', 'IR', 'JO', 'JP', 'KG', 'KH', 'KP', 'KR', 'KW', 'KZ', 'LA', 'LB', 'LK', 'MM', 'MN', 'MO', 'MV', 'MY', 'NP', 'OM', 'PH', 'PK', 'PS', 'QA', 'SA', 'SG', 'SY', 'TH', 'TJ', 'TL', 'TM', 'TW', 'UZ', 'VN', 'YE'],
  EU: ['AD', 'AL', 'AT', 'AX', 'BA', 'BE', 'BG', 'BY', 'CH', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FO', 'FR', 'GB', 'GG', 'GI', 'GR', 'HR', 'HU', 'IE', 'IM', 'IS', 'IT', 'JE', 'LI', 'LT', 'LU', 'LV', 'MC', 'MD', 'ME', 'MK', 'MT', 'NL', 'NO', 'PL', 'PT', 'RO', 'RS', 'RU', 'SE', 'SI', 'SJ', 'SK', 'SM', 'TR', 'UA', 'VA', 'XK'],
  NA: ['AG', 'AI', 'AN', 'AW', 'BB', 'BL', 'BM', 'BS', 'BZ', 'CA', 'CR', 'CU', 'DM', 'DO', 'GD', 'GL', 'GP', 'GT', 'HN', 'HT', 'JM', 'KN', 'KY', 'LC', 'MF', 'MQ', 'MS', 'MX', 'NI', 'PA', 'PM', 'PR', 'SV', 'TC', 'TT', 'US', 'VC', 'VG', 'VI'],
  OC: ['AS', 'AU', 'CK', 'FJ', 'FM', 'GU', 'KI', 'MH', 'MP', 'NC', 'NF', 'NR', 'NU', 'NZ', 'PF', 'PG', 'PN', 'PW', 'SB', 'TF', 'TK', 'TO', 'TV', 'VU', 'WF', 'WS'],
  SA: ['AR', 'BO', 'BR', 'CL', 'CO', 'CW', 'EC', 'FK', 'GF', 'GY', 'PE', 'PY', 'SR', 'UY', 'VE'],
};

const countriesListByRegion = [
  {
    label: 'Africa',
    options: [
      { value: 'DZ', label: 'Algeria (DZ)' },
      { value: 'AO', label: 'Angola (AO)' },
      { value: 'BJ', label: 'Benin (BJ)' },
      { value: 'BW', label: 'Botswana (BW)' },
      { value: 'BF', label: 'Burkina Faso (BF)' },
      { value: 'BI', label: 'Burundi (BI)' },
      { value: 'CM', label: 'Cameroon (CM)' },
      { value: 'CV', label: 'Cape Verde (CV)' },
      { value: 'CF', label: 'Central African Republic (CF)' },
      { value: 'TD', label: 'Chad (TD)' },
      { value: 'KM', label: 'Comoros (KM)' },
      { value: 'CD', label: 'Congo, Dem. Republic (CD)' },
      { value: 'CG', label: 'Congo, Republic (CG)' },
      { value: 'DJ', label: 'Djibouti (DJ)' },
      { value: 'EG', label: 'Egypt (EG)' },
      { value: 'GQ', label: 'Equatorial Guinea (GQ)' },
      { value: 'ER', label: 'Eritrea (ER)' },
      { value: 'ET', label: 'Ethiopia (ET)' },
      { value: 'GA', label: 'Gabon (GA)' },
      { value: 'GM', label: 'Gambia (GM)' },
      { value: 'GH', label: 'Ghana (GH)' },
      { value: 'GN', label: 'Guinea (GN)' },
      { value: 'GW', label: 'Guinea-Bissau (GW)' },
      { value: 'CI', label: 'Ivory Coast (CI)' },
      { value: 'KE', label: 'Kenya (KE)' },
      { value: 'LS', label: 'Lesotho (LS)' },
      { value: 'LR', label: 'Liberia (LR)' },
      { value: 'LY', label: 'Libya (LY)' },
      { value: 'MG', label: 'Madagascar (MG)' },
      { value: 'MW', label: 'Malawi (MW)' },
      { value: 'ML', label: 'Mali (ML)' },
      { value: 'MR', label: 'Mauritania (MR)' },
      { value: 'MU', label: 'Mauritius (MU)' },
      { value: 'YT', label: 'Mayotte (YT)' },
      { value: 'MA', label: 'Morocco (MA)' },
      { value: 'MZ', label: 'Mozambique (MZ)' },
      { value: 'NA', label: 'Namibia (NA)' },
      { value: 'NE', label: 'Niger (NE)' },
      { value: 'NG', label: 'Nigeria (NG)' },
      { value: 'RE', label: 'Reunion Island (RE)' },
      { value: 'RW', label: 'Rwanda (RW)' },
      { value: 'ST', label: 'Sao Tome and Príncipe (ST)' },
      { value: 'SN', label: 'Senegal (SN)' },
      { value: 'SC', label: 'Seychelles (SC)' },
      { value: 'SL', label: 'Sierra Leone (SL)' },
      { value: 'SO', label: 'Somalia (SO)' },
      { value: 'ZA', label: 'South Africa (ZA)' },
      { value: 'SS', label: 'South Sudan (SS)' },
      { value: 'SD', label: 'Sudan (SD)' },
      { value: 'SZ', label: 'Swaziland (SZ)' },
      { value: 'TZ', label: 'Tanzania (TZ)' },
      { value: 'TG', label: 'Togo (TG)' },
      { value: 'TN', label: 'Tunisia (TN)' },
      { value: 'UG', label: 'Uganda (UG)' },
      { value: 'EH', label: 'Western Sahara (EH)' },
      { value: 'ZM', label: 'Zambia (ZM)' },
      { value: 'ZW', label: 'Zimbabwe (ZW)' },
    ],
  },
  {
    label: 'Asia',
    options: [
      { value: 'AF', label: 'Afghanistan (AF)' },
      { value: 'AM', label: 'Armenia (AM)' },
      { value: 'AZ', label: 'Azerbaijan (AZ)' },
      { value: 'BH', label: 'Bahrain (BH)' },
      { value: 'BD', label: 'Bangladesh (BD)' },
      { value: 'BT', label: 'Bhutan (BT)' },
      { value: 'IO', label: 'British Indian Ocean Territory (IO)' },
      { value: 'BN', label: 'Brunei (BN)' },
      { value: 'MM', label: 'Burma (Myanmar) (MM)' },
      { value: 'KH', label: 'Cambodia (KH)' },
      { value: 'CN', label: 'China (CN)' },
      { value: 'CX', label: 'Christmas Island (CX)' },
      { value: 'CC', label: 'Cocos (Keeling) Islands (CC)' },
      { value: 'CY', label: 'Cyprus (CY)' },
      { value: 'TL', label: 'East Timor (TL)' },
      { value: 'GE', label: 'Georgia (GE)' },
      { value: 'HK', label: 'Hong Kong (HK)' },
      { value: 'IN', label: 'India (IN)' },
      { value: 'ID', label: 'Indonesia (ID)' },
      { value: 'IR', label: 'Iran (IR)' },
      { value: 'IQ', label: 'Iraq (IQ)' },
      { value: 'IL', label: 'Israel (IL)' },
      { value: 'JP', label: 'Japan (JP)' },
      { value: 'JO', label: 'Jordan (JO)' },
      { value: 'KZ', label: 'Kazakhstan (KZ)' },
      { value: 'KP', label: 'Korea, Dem. Republic of (KP)' },
      { value: 'KW', label: 'Kuwait (KW)' },
      { value: 'KG', label: 'Kyrgyzstan (KG)' },
      { value: 'LA', label: 'Laos (LA)' },
      { value: 'LB', label: 'Lebanon (LB)' },
      { value: 'MO', label: 'Macau (MO)' },
      { value: 'MY', label: 'Malaysia (MY)' },
      { value: 'MV', label: 'Maldives (MV)' },
      { value: 'MN', label: 'Mongolia (MN)' },
      { value: 'NP', label: 'Nepal (NP)' },
      { value: 'OM', label: 'Oman (OM)' },
      { value: 'PK', label: 'Pakistan (PK)' },
      { value: 'PS', label: 'Palestinian Territories (PS)' },
      { value: 'PH', label: 'Philippines (PH)' },
      { value: 'QA', label: 'Qatar (QA)' },
      { value: 'SA', label: 'Saudi Arabia (SA)' },
      { value: 'SG', label: 'Singapore (SG)' },
      { value: 'KR', label: 'South Korea (KR)' },
      { value: 'LK', label: 'Sri Lanka (LK)' },
      { value: 'SY', label: 'Syria (SY)' },
      { value: 'TW', label: 'Taiwan (TW)' },
      { value: 'TJ', label: 'Tajikistan (TJ)' },
      { value: 'TH', label: 'Thailand (TH)' },
      { value: 'TM', label: 'Turkmenistan (TM)' },
      { value: 'AE', label: 'United Arab Emirates (AE)' },
      { value: 'UZ', label: 'Uzbekistan (UZ)' },
      { value: 'VN', label: 'Vietnam (VN)' },
      { value: 'YE', label: 'Yemen (YE)' },
    ],
  },
  {
    label: 'Europe',
    options: [
      { value: 'AX', label: 'Aland Islands (AX)' },
      { value: 'AL', label: 'Albania (AL)' },
      { value: 'AD', label: 'Andorra (AD)' },
      { value: 'AT', label: 'Austria (AT)' },
      { value: 'BY', label: 'Belarus (BY)' },
      { value: 'BE', label: 'Belgium (BE)' },
      { value: 'BA', label: 'Bosnia and Herzegovina (BA)' },
      { value: 'BG', label: 'Bulgaria (BG)' },
      { value: 'HR', label: 'Croatia (HR)' },
      { value: 'CZ', label: 'Czech Republic (CZ)' },
      { value: 'DK', label: 'Denmark (DK)' },
      { value: 'EE', label: 'Estonia (EE)' },
      { value: 'FO', label: 'Faroe Islands (FO)' },
      { value: 'FI', label: 'Finland (FI)' },
      { value: 'FR', label: 'France (FR)' },
      { value: 'DE', label: 'Germany (DE)' },
      { value: 'GI', label: 'Gibraltar (GI)' },
      { value: 'GR', label: 'Greece (GR)' },
      { value: 'GG', label: 'Guernsey (GG)' },
      { value: 'HU', label: 'Hungary (HU)' },
      { value: 'IS', label: 'Iceland (IS)' },
      { value: 'IE', label: 'Ireland (IE)' },
      { value: 'IT', label: 'Italy (IT)' },
      { value: 'JE', label: 'Jersey (JE)' },
      { value: 'XK', label: 'Kosovo (XK)' },
      { value: 'LV', label: 'Latvia (LV)' },
      { value: 'LI', label: 'Liechtenstein (LI)' },
      { value: 'LT', label: 'Lithuania (LT)' },
      { value: 'LU', label: 'Luxembourg (LU)' },
      { value: 'MK', label: 'Macedonia (MK)' },
      { value: 'MT', label: 'Malta (MT)' },
      { value: 'IM', label: 'Man Island (IM)' },
      { value: 'MD', label: 'Moldova (MD)' },
      { value: 'MC', label: 'Monaco (MC)' },
      { value: 'ME', label: 'Montenegro (ME)' },
      { value: 'NL', label: 'Netherlands (NL)' },
      { value: 'NO', label: 'Norway (NO)' },
      { value: 'PL', label: 'Poland (PL)' },
      { value: 'PT', label: 'Portugal (PT)' },
      { value: 'RO', label: 'Romania (RO)' },
      { value: 'RU', label: 'Russia (RU)' },
      { value: 'SM', label: 'San Marino (SM)' },
      { value: 'RS', label: 'Serbia (RS)' },
      { value: 'SK', label: 'Slovakia (SK)' },
      { value: 'SI', label: 'Slovenia (SI)' },
      { value: 'ES', label: 'Spain (ES)' },
      { value: 'SJ', label: 'Svalbard and Jan Mayen (SJ)' },
      { value: 'SE', label: 'Sweden (SE)' },
      { value: 'CH', label: 'Switzerland (CH)' },
      { value: 'TR', label: 'Turkey (TR)' },
      { value: 'UA', label: 'Ukraine (UA)' },
      { value: 'GB', label: 'United Kingdom (GB)' },
      { value: 'VA', label: 'Vatican City State (VA)' },
    ],
  },
  {
    label: 'North America',
    options: [
      { value: 'AI', label: 'Anguilla (AI)' },
      { value: 'AG', label: 'Antigua and Barbuda (AG)' },
      { value: 'AW', label: 'Aruba (AW)' },
      { value: 'BS', label: 'Bahamas (BS)' },
      { value: 'BB', label: 'Barbados (BB)' },
      { value: 'BQ', label: 'Barbecue (BQ)' },
      { value: 'BZ', label: 'Belize (BZ)' },
      { value: 'BM', label: 'Bermuda (BM)' },
      { value: 'CA', label: 'Canada (CA)' },
      { value: 'KY', label: 'Cayman Islands (KY)' },
      { value: 'CR', label: 'Costa Rica (CR)' },
      { value: 'CU', label: 'Cuba (CU)' },
      { value: 'DM', label: 'Dominica (DM)' },
      { value: 'DO', label: 'Dominican Republic (DO)' },
      { value: 'SV', label: 'El Salvador (SV)' },
      { value: 'GL', label: 'Greenland (GL)' },
      { value: 'GD', label: 'Grenada (GD)' },
      { value: 'GP', label: 'Guadeloupe (GP)' },
      { value: 'GT', label: 'Guatemala (GT)' },
      { value: 'HT', label: 'Haiti (HT)' },
      { value: 'HN', label: 'Honduras (HN)' },
      { value: 'JM', label: 'Jamaica (JM)' },
      { value: 'MQ', label: 'Martinique (MQ)' },
      { value: 'MX', label: 'Mexico (MX)' },
      { value: 'MS', label: 'Montserrat (MS)' },
      { value: 'AN', label: 'Netherlands Antilles (AN)' },
      { value: 'NI', label: 'Nicaragua (NI)' },
      { value: 'PA', label: 'Panama (PA)' },
      { value: 'PR', label: 'Puerto Rico (PR)' },
      { value: 'BL', label: 'Saint Barthelemy (BL)' },
      { value: 'KN', label: 'Saint Kitts and Nevis (KN)' },
      { value: 'LC', label: 'Saint Lucia (LC)' },
      { value: 'MF', label: 'Saint Martin (MF)' },
      { value: 'PM', label: 'Saint Pierre and Miquelon (PM)' },
      { value: 'VC', label: 'Saint Vincent and the Grenadines (VC)' },
      { value: 'TT', label: 'Trinidad and Tobago (TT)' },
      { value: 'TC', label: 'Turks and Caicos Islands (TC)' },
      { value: 'US', label: 'United States (US)' },
      { value: 'VG', label: 'Virgin Islands (British) (VG)' },
      { value: 'VI', label: 'Virgin Islands (U.S.) (VI)' },
    ],
  },
  {
    label: 'Oceania',
    options: [
      { value: 'AS', label: 'American Samoa (AS)' },
      { value: 'AQ', label: 'Antartica (AQ)' },
      { value: 'AU', label: 'Australia (AU)' },
      { value: 'BV', label: 'Bouvet Island (BV)' },
      { value: 'CK', label: 'Cook Islands (CK)' },
      { value: 'FJ', label: 'Fiji (FJ)' },
      { value: 'PF', label: 'French Polynesia (PF)' },
      { value: 'TF', label: 'French Southern Territories (TF)' },
      { value: 'GU', label: 'Guam (GU)' },
      { value: 'KI', label: 'Kiribati (KI)' },
      { value: 'MH', label: 'Marshall Islands (MH)' },
      { value: 'FM', label: 'Micronesia (FM)' },
      { value: 'NR', label: 'Nauru (NR)' },
      { value: 'NC', label: 'New Caledonia (NC)' },
      { value: 'NZ', label: 'New Zealand (NZ)' },
      { value: 'NU', label: 'Niue (NU)' },
      { value: 'NF', label: 'Norfolk Island (NF)' },
      { value: 'MP', label: 'Northern Mariana Islands (MP)' },
      { value: 'PW', label: 'Palau (PW)' },
      { value: 'PG', label: 'Papua New Guinea (PG)' },
      { value: 'PN', label: 'Pitcairn (PN)' },
      { value: 'WS', label: 'Samoa (WS)' },
      { value: 'SB', label: 'Solomon Islands (SB)' },
      { value: 'TK', label: 'Tokelau (TK)' },
      { value: 'TO', label: 'Tonga (TO)' },
      { value: 'TV', label: 'Tuvalu (TV)' },
      { value: 'VU', label: 'Vanuatu (VU)' },
      { value: 'WF', label: 'Wallis and Futuna (WF)' },
    ],
  },
  {
    label: 'South America',
    options: [
      { value: 'AR', label: 'Argentina (AR)' },
      { value: 'BO', label: 'Bolivia (BO)' },
      { value: 'BR', label: 'Brazil (BR)' },
      { value: 'CL', label: 'Chile (CL)' },
      { value: 'CO', label: 'Colombia (CO)' },
      { value: 'CW', label: 'Curacao (CW)' },
      { value: 'EC', label: 'Ecuador (EC)' },
      { value: 'FK', label: 'Falkland Islands (FK)' },
      { value: 'GF', label: 'French Guiana (GF)' },
      { value: 'GY', label: 'Guyana (GY)' },
      { value: 'PY', label: 'Paraguay (PY)' },
      { value: 'PE', label: 'Peru (PE)' },
      { value: 'SR', label: 'Suriname (SR)' },
      { value: 'UY', label: 'Uruguay (UY)' },
      { value: 'VE', label: 'Venezuela (VE)' },
    ],
  },
];

export { zones, countriesListByRegion };



// WEBPACK FOOTER //
// ./src/utils/countries.js